import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTranslation } from "react-i18next"

import "./dropzone.scss"

const Dropzone = ({ getInputProps }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <div className='flex flex-row m-3'>
      <div className='flex items-center justify-end upload-text w-25'>
        <FontAwesomeIcon
          icon={["fal", "cloud-arrow-up"]}
          className='p-1 text-xl lite-dropzone-icon w-50 h-50 upload-text'
        />
      </div>
      <div className='flex items-center justify-center text-center w-50'>
        <p className='m-0 text-center'>
          <span className='ml-2 text-base upload-text'>
            {t("importar.dropDown.textMsgOne")}
            <br />
            {t("importar.dropDown.textMsgTwo")}{" "}
            <span className='upload-link'>
              {t("importar.dropDown.textMsgThree")}
            </span>
          </span>
        </p>
      </div>

      <input {...getInputProps()} />
    </div>
  )
}

export default Dropzone
